import config from "./config";

export const getImageUrl = (id: string) => `${config.cdnUrl}/${id}`;
